var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 4.5835C16.8011 4.5835 17.4167 5.1991 17.4167 5.9585C17.4167 6.71789 16.8011 7.3335 16.0417 7.3335C15.2824 7.3335 14.6667 6.71789 14.6667 5.9585C14.6667 5.1991 15.2824 4.5835 16.0417 4.5835Z",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54297 10.2152C1.62341 11.2422 1.60363 12.7916 2.44757 13.8816C4.12227 16.0446 5.95527 17.8776 8.11822 19.5522C9.20821 20.3962 10.7576 20.3764 11.7847 19.4569C14.573 16.9603 17.1265 14.3512 19.5908 11.4838C19.8345 11.2004 19.9868 10.853 20.021 10.4807C20.1723 8.83473 20.483 4.09253 19.1952 2.80468C17.9073 1.51683 13.1651 1.82754 11.5191 1.97878C11.1469 2.01299 10.7994 2.16539 10.5159 2.40902C7.6487 4.87334 5.03958 7.42685 2.54297 10.2152Z",
    stroke: "#2E2C27",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 12.8335L9.16673 15.5835",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.8c90cfeb5f70b5d8f37ee9cf9ce02709.svg";
export { ForwardRef as ReactComponent };